module.exports = __webpack_public_path__ + "img/portraits_23_V.251bc698.webp";